module.exports = "<div class=\"top-bar row border-bottom\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/top-bar/top-bar.html
// module id = 483
// module chunks = 0